import { Close } from '@mui/icons-material';
import { Alert, Card, CardContent, Stack, Typography } from '@mui/material';

interface ErrorSectionProps {
  errors: { message: string }[];
}

export const ErrorSection: React.FC<ErrorSectionProps> = ({ errors }) => (
  <Card sx={{ mb: 3 }}>
    <CardContent sx={{ p: 1.5, pb: '12px !important' }}>
      <Stack>
        <Alert variant="outlined" severity="error" sx={{ mb: 2 }}>
          Action Needed: {errors?.length} field(s) are missing. Please provide the required details.
        </Alert>
        <Stack sx={{ gap: 1 }}>
          {errors?.map((error, index) => (
            <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }} key={error.message}>
              <Close />
              <Typography variant="subtitle2" id={`error-${index}`}>
                {error?.message || error}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);
